import { ReactNode } from 'react';
import Flex from '@creditflowresearch/uilib/Flex';
import cn from 'classnames';

import styles from './filterSectionHeader.module.scss';

interface IProps {
  title: ReactNode,
  leftSlot?: ReactNode,
  rightSlot?: ReactNode,
}

const FilterSectionHeader = ({
  title,
  leftSlot,
  rightSlot,
}: IProps) => (
  <Flex
    justify="space-between"
    gap={ 10 }
    className={ styles.headerContent }
  >
    { leftSlot }
    <Flex as="label" className={ cn(styles.title, { [styles.noOffset]: leftSlot }) }>{ title }</Flex>
    { rightSlot }
  </Flex>
);

export default FilterSectionHeader;
